<template>
  <div class="new-card">
    <div class="new-card-types">
      <div class="new-card-types-item" :class="{ active: type === 1 }" @click="type = 1">
        <div class="new-card-types-item-logo sinopec"></div>
        <div class="new-card-types-item-name">中国石化</div>
      </div>
      <div class="line"></div>
      <div class="new-card-types-item" :class="{ active: type === 2 }" @click="type = 2">
        <div class="new-card-types-item-logo petrol"></div>
        <div class="new-card-types-item-name">中国石油</div>
      </div>
    </div>

    <div class="new-card-amount">
      <van-form ref="form" :show-error-message="false" validate-trigger="onSubmit">
        <van-field
          class="new-card-amount-input"
          v-model.trim="oilNum"
          placeholder="请输入加油卡卡号"
          :disabled="disabled"
          :rules="rules.oilNum"
          :maxlength="noLen"
          type="digit"
          name="oilNum"
        />
        <div class="new-card-amount-tips" :class="{show: errMsg['oilNum']}">{{ errMsg['oilNum'] }}</div>
        <van-field
          class="new-card-amount-input"
          v-model.trim="mobile"
          placeholder="请输入持卡人手机号"
          :disabled="disabled"
          :rules="rules.mobile"
          maxlength="11"
          type="digit"
          name="mobile"
        />
        <div class="new-card-amount-tips" :class="{show: errMsg['mobile']}">{{ errMsg['mobile'] }}</div>
      </van-form>
    </div>

    <van-button class="new-card-btn" type="info" :disabled="disabled" @click="submit">
      确认添加
    </van-button>
  </div>
</template>

<script>
import { REGEX_PHONE, ZSH_REGEX_OIL, ZSY_REGEX_OIL } from "@/common/regex.js";
import { addCard } from "@/common/api";
import { Toast } from 'vant'

export default {
  name: "new-card",
  data() {
    return {
      disabled: false,
      errMsg: {
        oilNum: '',
        mobile: ''
      },
      type: 1,
      oilNum: "",
      mobile: "",
      rules: {
        // 联系电话
        mobile: [
          {required: true, message: "手机号不能为空"},
          {pattern: REGEX_PHONE, message: "请输入正确的手机号"},
        ],
        oilNum: [
          {required: true, message: "加油卡号不能为空"},
          {pattern: ZSH_REGEX_OIL, message: "请输入以100011开头共19位加油卡号"},
        ],
      },
    };
  },
  computed: {
    noLen() {
      return this.type === 1 ? 19 : 16
    }
  },
  watch: {
    type(val) {
      let oilRule
      if (val === 1) {
        oilRule = {pattern: ZSH_REGEX_OIL, message: "请输入以100011开头共19位加油卡号"}
      } else {
        oilRule = {pattern: ZSY_REGEX_OIL, message: "请输入以90开头共16位加油卡号"}
      }
      // 两种加油卡类型长度不一致，先清空
      this.oilNum = ''
      this.rules.oilNum[1] = oilRule
    }
  },
  methods: {
    clearValidateMsg() {
      this.errMsg['oilNum'] = ''
      this.errMsg['mobile'] = ''
    },
    async submit() {
      // 校验表单
      let invalid = false;
      let that = this;
      await that.$refs.form.validate().catch((err) => {
        invalid = true;
        this.clearValidateMsg()
        err.forEach(item => {
          this.errMsg[item.name] = item.message
        })
        that.$toast(err[0].message);
      });
      if (invalid) return;

      try {
        await addCard({
          cardCode: this.oilNum,
          cardType: 1,
          phone: this.mobile,
          productType: this.type,
        })
        Toast('添加成功');
        this.$router.back();
      } catch (e) {
        // err handle
      }
    },
  },
  created() {
  },
};
</script>

<style lang="scss" scoped>
.new-card {
  min-height: 100vh;

  &-types {
    display: flex;
    height: 2rem;
    justify-content: center;
    align-items: center;

    &-item {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 2.8rem;
      height: 1.2rem;
      border: 0.02rem solid transparent;

      &-logo {
        width: 0.72rem;
        height: 0.72rem;
        background-size: cover;
        margin-right: 0.16rem;

        &.sinopec {
          background-image: url("./assets/sinopec_logo.png");
        }

        &.petrol {
          background-image: url("./assets/petrol_china_logo.png");
        }
      }

      &-name {
        font-size: 0.36rem;
        color: #383838;
        letter-spacing: 0.54px;
        font-weight: 500;
      }

      &.active {
        border-color: #3399ff;
        border-radius: 0.16rem;
        background-color: #cce6ff;
      }
    }

    > .line {
      width: 0.02rem;
      height: 0.73rem;
      background-color: #e6e6e6;
      margin: 0 0.55rem;
    }
  }

  &-amount {
    position: relative;
    padding-top: .3rem;
    &-input {
      font-size: 0.4rem;
      width: auto;
      margin: 0.32rem 0.4rem 0 0.4rem;
      padding: 0;
      line-height: .56rem;
      padding-bottom: 0.32rem;
      background-color: white;
      border-bottom: 0.02rem solid rgba(230, 230, 230, 1);
    }

    &-tips {
      visibility: hidden;
      margin-top: 0.08rem;
      height: .4rem;
      line-height: .4rem;
      margin-left: 0.4rem;
      font-size: 0.28rem;
      color: #ff4242;
      &.show {
        visibility: visible;
      }
    }
  }

  &-btn {
    display: block;
    width: 6.7rem;
    height: 0.96rem;
    font-size: 0.36rem;
    border-radius: 0.16rem;
    margin: 0 auto;
    margin-top: .72rem;
  }
}
</style>
